import { IntlFormatters } from 'react-intl'
import { BASE_MONEY_FORMAT } from '../../../../../constants'
import { MembershipFeesQueryType } from '../../../../../types'
import { MaybeString } from '../../../../../utils'
import { UserInfo } from '../../../../../utils/classes/graphql'
import { CalculateMembershipFeeInput, PaymentInfoType } from '../../types'
import {
  getReferenceNumber,
  getVirtualBarCode,
  makeDueDate,
  parseAmount
} from '../../utils'

interface PaymentInfoProps {
  error?: string
  paymentInfo?: PaymentInfoType
}

export const createPaymentInfo = (
  bankAccounts: MembershipFeesQueryType['bankAccounts'],
  user: UserInfo,
  values: CalculateMembershipFeeInput,
  formatMessage: IntlFormatters['formatMessage']
): PaymentInfoProps => {
  const getReferenceOrError = () => {
    let reference
    try {
      reference = getReferenceNumber(values, user)
    } catch (e) {}

    return {
      reference,
      referenceErrorId: reference
        ? undefined
        : 'pages.membershipFeesPage.calculateMembershipFeePage.referenceInvalid'
    }
  }

  const calculateAmount = () => {
    const parsedAmount = parseAmount(values)
    const formattedAmount = BASE_MONEY_FORMAT.format(parsedAmount)

    return formattedAmount
  }

  const getDueDate = () => {
    const dueDateText: MaybeString = formatMessage({
      id: 'pages.membershipFeesPage.calculateMembershipFeePage.dueDatePassed'
    })

    return makeDueDate(values) || dueDateText
  }

  const getVirtualBarCodeOrError = () => {
    let barCode
    try {
      barCode = getVirtualBarCode(values, user, bankAccounts)
    } catch (e) {}

    return {
      barCode,
      barCodeErrorId: barCode
        ? undefined
        : 'pages.membershipFeesPage.calculateMembershipFeePage.missingInfoOnBarCode'
    }
  }

  const paymentInfoProps: PaymentInfoProps = {}

  let errorId

  try {
    const { reference, referenceErrorId } = getReferenceOrError()
    const { barCode, barCodeErrorId } = getVirtualBarCodeOrError()

    if (reference && barCode) {
      paymentInfoProps.paymentInfo = {
        reference,
        amount: calculateAmount(),
        dueDate: getDueDate(),
        virtualBarCode: barCode
      }
    } else {
      errorId = referenceErrorId || barCodeErrorId
    }
  } catch (e) {
    errorId = 'pages.membershipFeesPage.calculateMembershipFeePage.error'
  }

  paymentInfoProps.error = errorId
    ? formatMessage({
        id: errorId
      })
    : undefined

  return paymentInfoProps
}
